import React, { useMemo } from 'react';

const PriceLabel = ({ amount, defaultValue = '-', currency = '', className = '' }) => {
  const formattedValue = useMemo(() => {    
    // 1. بررسی مقادیر خالی
    if (amount === null || amount === undefined || amount === '') {
      return defaultValue;
    }

    // 2. نرمال‌سازی: پاک کردن هرگونه کامای اضافی برای تبدیل به عدد خام
    // (ورودی را به فرمت عددیِ جاوااسکریپتی تبدیل می‌کنیم)
    const cleanStr = amount.toString().replace(/,/g, '');
    const num = parseFloat(cleanStr);

    if (isNaN(num)) return defaultValue;

    // 3. جداسازی بخش صحیح و اعشاری
    // چون parseFloat همیشه اعشار را با نقطه جدا می‌کند
    const [integerPart, decimalPart] = num.toString().split('.');

    // 4. فرمت‌بندی بخش صحیح با کاما
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    // 5. ترکیب مجدد با کاما برای اعشار (طبق درخواست شما)
    if (decimalPart) {
      return `${formattedInteger}.${decimalPart}`;
    }

    return formattedInteger;
  }, [amount]);

  return (
    <span className={`price-label ${className}`}>
     {' '} {formattedValue} {amount !== null && amount !== undefined && currency}
    </span>
  );
};

export default PriceLabel;
